import { UserGetInfoResponse } from '@trucksmarter/shared';
import { makeClientSideRequest } from '@lib/api/client/http-client';
import Endpoint from '@lib/api/endpoints';

export default async function fetchUserInfo(signal?: AbortSignal) {
  return makeClientSideRequest<void, UserGetInfoResponse>(
    Endpoint.UsersGetInfo,
    undefined,
    { signal },
  );
}
